
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import SettingDescriber from '@/components/shared/SettingDescriber.vue';

@Component<CustomMenuBrowseStyles>({
	components: {
		SettingDescriber
	}
})
export default class CustomMenuBrowseStyles extends Vue {
	@Prop({ type: Object, default: () => {} }) private targetMenuConfig!: MenuConfiguration;

	private mutableMenuConfiguration: MenuConfiguration = cloneDeep(this.targetMenuConfig);
	private gridView: boolean = !!(this.mutableMenuConfiguration.browse_menu_style && this.mutableMenuConfiguration.browse_menu_style === 'gallery');;

	private changeBrowseStyle(value: boolean): void {
		const browseStyleValue = value ? 'gallery' : 'list';
		Vue.set(this.mutableMenuConfiguration, 'browse_menu_style', browseStyleValue);
		this.$emit('update-menu-config', { browse_menu_style: browseStyleValue });
	}
}
